<template>
  <div class="Dashboard Operational">
    <v-container fluid grid-list-md>
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <v-card>
            <v-tabs
            v-model="tabs"
            fixed-tabs
            color="transparent"
            slider-color="iK"
            :key="tabsKey"
            >
            <v-tab :key="tabAdvance" ripple>
              Avance
            </v-tab>
            <v-tab :key="tabCober" v-if="dataValsMuestra.length > 0" ripple>
              Cobertura
            </v-tab>
            <v-tab :key="tabInc" ripple>
              Incidencias
            </v-tab>
            <v-tab :key="tabTel" v-if="telefonico === null" ripple>
              Telefónico
            </v-tab>
            <v-tab :key="tabSavedRep" v-if="savedReports !== null" ripple>
              Guardados
            </v-tab>

            <v-tab-item :key="tabAdvance">
              <v-layout row wrap justify-center>
                <v-flex xs12 md5 lg4>
                  <v-card>
                    <v-card-title class="title">
                      Porcentaje de Cobertura
                    </v-card-title>

                    <v-card-text
                    v-if="loadingCober"
                    class="text-xs-center"
                    >
                    <v-progress-circular
                    :size="progressSize"
                    :width="progressWidth"
                    color="info"
                    indeterminate
                    ></v-progress-circular>
                  </v-card-text>

                  <v-card-text v-else>
                    <radial-chart
                    :chartOptions="chartOptionsCober"
                    :chartSeries="chartSeriesCober"
                    :key="chartCoberKey"
                    />
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex xs12 md10 lg8>
                <v-card>
                  <v-card-title class="title">
                    Avance General del Operativo
                    <v-spacer/>
                    <v-card-actions>
                      <v-btn color="info"
                      :disabled="loadingAdv"
                      @click="ChangeAdvance()"
                      v-text="advance ? 'Ver Acumulado' : 'Ver Diario'"
                      >
                    </v-btn>
                  </v-card-actions>
                </v-card-title>

                <v-card-text
                v-if="loadingAdv"
                class="text-xs-center"
                >
                <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
                ></v-progress-circular>
              </v-card-text>

              <v-card-text v-else>
                <chart-line
                :chartOptions="chartOptionsAdv"
                :chartSeries="chartSeriesAdv"
                :key="chartAdvKey"
                />
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-tab-item>

      <v-tab-item :key="tabCober" v-if="dataValsMuestra.length > 0">
        <v-layout row wrap justify-center>
          <v-flex xs12 md10 lg8>
            <v-card>
              <v-card-title class="title">
                Cobertura de Muestra
                <v-spacer/>
                <v-card-actions v-if="dataValsMuestra.length > 0">
                  <v-btn color="info" :disabled="dataValsMuestra.length < 1">
                    <download-csv
                    :data="dataValsMuestra"
                    :name="'Cobertura de Muestra.csv'"
                    :labels="labelsMuestra"
                    :fields="fieldsMuestra"
                    >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text
            v-if="loadMuestra"
            class="text-xs-center"
            >
            <v-progress-circular
            :size="progressSize"
            :width="progressWidth"
            color="info"
            indeterminate
            ></v-progress-circular>
          </v-card-text>

          <v-card-text v-if="dataValsMuestra.length > 0">
            <v-autocomplete
            v-if="savedMuestra.length > 0"
            :items="savedMuestra"
            label="Tipo de Cobertura"
            v-model="selectedMuestra"
            :disabled="loadingMuestra"
            color="secondary"
            item-text="nombre"
            return-object
            no-data-text="No se tienen Muestras Guardados."
            ></v-autocomplete>

            <data-table
            :headers="headersMuestra"
            :dataVals="dataValsMuestra"
            :searchActive="true"
            :key="tableMuestraKey"
            />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-tab-item>

  <v-tab-item :key="tabInc">
    <v-layout row wrap justify-center>
      <v-flex xs12 md10 lg8>

        <v-card>
          <v-card-title class="title">Filtros</v-card-title>
          <v-flex xs12 sm6 d-flex>
            <v-select
            :items="list_departamentos"
            :disabled="list_departamentos.length == 0"
            v-model="select_dep"
            label="Deparamentos"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-select
            :items="list_municipios"
            v-model="select_mun"
            :disabled="select_dep == false"
            label="Municipios"
            > </v-select>
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-select
            :items="list_mnz"
            v-model="select_mnz"
            :disabled="select_mun == false"
            label="Manzanas"
            > </v-select>
          </v-flex>
          <v-btn v-on:click="getIncidencias">Consultar</v-btn>
        </v-card>

        <v-expansion-panel
        value=1
        popout>

        <v-expansion-panel-content>
          <template v-slot:header>
            <div class="subheading">Incidencias por encuestador</div>
          </template>
          <v-card>
            <v-btn color="info" :disabled="dataValsEncInc.length < 1">
              <download-csv
              :data="dataValsEncInc"
              :name="'IncideciasXEncuestador.csv'"
              >
              <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
            </download-csv>
          </v-btn>
          <v-card-text v-if="dataValsEncInc.length > 0">

            <table-base
            :headers="headersEncInc"
            :dataVals="dataValsEncInc"
            :searchActive="true"
            :key="tableMuestraKey"
            />
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>

      <v-expansion-panel-content>
        <template v-slot:header>
          <div class="subheading">Incidencias por Hogar</div>
        </template>
        <v-card>
          <v-btn color="info" :disabled="dataValsEncInc.length < 1">
            <download-csv
            :data="dataValsEncInc"
            :name="'IncideciasXEncuestador.csv'"
            >
            <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
          </download-csv>
        </v-btn>
        <v-card-text v-if="dataValsHogInc.length > 0">

          <table-base
          :headers="headersHogInc"
          :dataVals="dataValsHogInc"
          :searchActive="true"
          :key="tableMuestraKey"
          />
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>

    <v-expansion-panel-content>
      <template v-slot:header>
        <div class="subheading">Incidencias por Vivienda</div>
      </template>
      <v-card>
        <v-btn color="info" :disabled="dataValsEncInc.length < 1">
          <download-csv
          :data="dataValsVivInc"
          :name="'IncideciasXVivienda.csv'"
          >
          <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
        </download-csv>
      </v-btn>
      <v-card-text v-if="dataValsVivInc.length > 0">

        <table-base
        :headers="headersVivInc"
        :dataVals="dataValsVivInc"
        :searchActive="true"
        :key="tableMuestraKey"
        />
      </v-card-text>
    </v-card>
  </v-expansion-panel-content>
</v-expansion-panel>
</v-flex>
</v-layout>
</v-tab-item>

<v-tab-item :key="tabTel" v-if="telefonico === null">
  <v-layout row wrap>
    <v-flex xs6>
      <v-flex height="100%">
        <v-card v-if="loadingMarc">
          <v-card-text
          v-if="loading"
          class="text-xs-center"
          >
          <v-progress-circular
          class="text-xs-center"
          :size="progressSize"
          :width="progressWidth"
          color="info"
          indeterminate
          ></v-progress-circular>
        </v-card-text>
      </v-card>

      <v-card v-else>
        <v-card-title class="title">
          Marcaciones
          <v-spacer/>

          <v-card-actions>
            <v-spacer/>
            <v-btn color="info" :disabled="dataValsMarc === null">
              <download-csv
              :data="dataValsMarc"
              :name="'Reporte de Marcaciones.csv'"
              :labels="labelsMarc"
              :fields="fieldsMarc"
              >
              <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
            </download-csv>
          </v-btn>
        </v-card-actions>
      </v-card-title>

      <v-card-text>
        <table-base
        :headers="headersMarc"
        :dataVals="dataValsMarc"
        :key="tableKeyMarc"
        disable-initial-sort
        />
      </v-card-text>
    </v-card>
  </v-flex>
</v-flex>

<v-flex xs6>
  <v-flex height="100%">
    <v-card v-if="loadingInci">
      <v-card-text
      v-if="loading"
      class="text-xs-center"
      >
      <v-progress-circular
      class="text-xs-center"
      :size="progressSize"
      :width="progressWidth"
      color="info"
      indeterminate
      ></v-progress-circular>
    </v-card-text>
  </v-card>

  <v-card v-else>
    <v-card-title class="title">
      Incidencias
      <v-spacer/>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="info" :disabled="dataValsInci === null">
          <download-csv
          :data="dataValsInci"
          :name="'Reporte de Incidencias.csv'"
          :labels="labelsInci"
          :fields="fieldsInci"
          >
          <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
        </download-csv>
      </v-btn>
    </v-card-actions>
  </v-card-title>

  <v-card-text>
    <table-base
    :headers="headersInci"
    :dataVals="dataValsInci"
    :key="tableKeyInci"
    disable-initial-sort
    />
  </v-card-text>
</v-card>
</v-flex>
</v-flex>
</v-layout>
<v-layout row wrap justify-center>
  <v-flex xs6>
    <v-flex height="100%">
      <v-card v-if="loadingAgeResp">
        <v-card-text
        v-if="loading"
        class="text-xs-center"
        >
        <v-progress-circular
        class="text-xs-center"
        :size="progressSize"
        :width="progressWidth"
        color="info"
        indeterminate
        ></v-progress-circular>
      </v-card-text>
    </v-card>

    <v-card v-else>
      <v-card-title class="title">
        Agente
        <v-spacer/>

        <v-card-actions>
          <v-spacer/>
          <v-btn color="info" :disabled="dataValsAge === null || selectedAge === null">
            <download-csv
            :data="dataValsAge"
            :name="'Reporte de Agente ' + selectedAge + '.csv'"
            :labels="labelsAge"
            :fields="fieldsAge"
            >
            <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
          </download-csv>
        </v-btn>
      </v-card-actions>
    </v-card-title>

    <v-autocomplete class="mx-2 px-2"
    :items="savedAge"
    label="Seleccione el agente"
    v-model="selectedAge"
    color="secondary"
    item-text="usuario"
    return-object
    no-data-text="No se tienen agentes."
    ></v-autocomplete>
    <v-card-text>
      <table-base
      :headers="headersAge"
      :dataVals="dataValsAge"
      :key="tableKeyAge"
      :disabled="selectedAge == false"
      />
    </v-card-text>
  </v-card>
</v-flex>
</v-flex>
</v-layout>
</v-tab-item>

<v-tab-item :key="tabSavedRep" v-if="savedReports !== null">
  <v-layout row wrap justify-center>
    <v-flex xs12 lg10>
      <v-card class="px-3">
        <v-card-title class="title">
          Reportes Guardados
        </v-card-title>

        <v-layout wrap align-start justify-center row fill-height>
          <v-flex xs12 md3>
            <v-menu
            :close-on-content-click="false"
            v-model="menuIniReports"
            transition="scale-transition"
            offset-y
            full-width
            :nudge-right="40"
            max-width="290px"
            min-width="290px"
            >
            <v-text-field
            slot="activator"
            label="Fecha Inicial"
            v-model="dateIniReports"
            prepend-icon="event"
            readonly
            hint="Debe ser anterior a la fecha final"
            persistent-hint
            ></v-text-field>
            <v-date-picker
            v-model="dateIniReports"
            locale="es-CO"
            no-title
            scrollable
            actions
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-spacer/>

        <v-flex xs12 md3>
          <v-menu
          :close-on-content-click="false"
          v-model="menuEndReports"
          transition="scale-transition"
          offset-y
          full-width
          :nudge-right="40"
          max-width="290px"
          min-width="290px"
          >
          <v-text-field
          slot="activator"
          label="Fecha Final"
          v-model="dateEndReports"
          prepend-icon="event"
          readonly
          hint="Debe ser posterior a la fecha inicial"
          persistent-hint
          ></v-text-field>
          <v-date-picker
          v-model="dateEndReports"
          locale="es-CO"
          no-title
          scrollable
          actions
          ></v-date-picker>
        </v-menu>
      </v-flex>

      <v-spacer/>

      <v-flex xs12>
        <v-autocomplete
        :items="savedReports"
        label="Reportes"
        v-model="selectedReport"
        :disabled="loadingReports"
        color="secondary"
        item-text="nombre"
        return-object
        hide-no-data
        no-data-text="No se tienen Reportes Guardados."
        ></v-autocomplete>
      </v-flex>

      <v-card-text
      v-if="loadingReports"
      class="text-xs-center"
      >
      <v-progress-circular
      class="text-xs-center"
      :size="progressSize"
      :width="progressWidth"
      color="info"
      indeterminate
      ></v-progress-circular>
    </v-card-text>

    <v-flex xs12 v-else-if="selectedReport">
      <v-card>
        <report-multiple
        :data="dataReports"
        :csvname="csvnameReports"
        :questionsShow="selectedReport.data.questions"
        />
      </v-card>
    </v-flex>
  </v-layout>
</v-card>
</v-flex>
</v-layout>
</v-tab-item>
</v-tabs>
</v-card>
</v-flex>

<!-- <v-flex xs12 lg6>
<v-card flat :key="chartGSKey">
<v-card-title class="title">
Segregación por Sexo
</v-card-title>

<v-card-text>
<chart-column
:chartOptions="chartOptionsGS"
:chartSeries="chartSeriesGS"
:key="chartGSKey"
/>
</v-card-text>
</v-card>
</v-flex> -->

<!-- <v-flex xs12>
<v-card flat>
<v-card-title class="title">
Otra Grafica
</v-card-title>

<v-card-text>
Selección
<chart-line
:chartOptions="chartOptionsBrush"
:chartSeries="chartSeriesAdv"
:key="brushKey"
/>
</v-card-text>

<v-card-text>
Global
<chart-line
:chartOptions="chartOptionsLineBrush"
:chartSeries="chartSeriesAdv"
:key="brushKey"
/>
</v-card-text>

<v-card-text>
<div id="wrapper">
<div id="chart-line2">
<apexchart
type="line"
height="230"
:options="chartOptionsBrush"
:series="chartSeriesAdv"
></apexchart>
</div>
<div id="chart-line">
<apexchart
type="area"
height="130"
:options="chartOptionsLineBrush"
:series="chartSeriesAdv"
></apexchart>
</div>
</div>
</v-card-text>
</v-card>
</v-flex> -->
</v-layout>

<!-- <v-layout wrap>
<v-flex xs12>
<v-layout row wrap>
<v-flex>
</v-flex>

<v-flex>
</v-flex>
</v-layout>
</v-flex>
</v-layout> -->
</v-container>
</div>
</template>

<script>
// import moment from 'moment'
import chartLine from '@/components/Charts/LineBase'
import RadialBase from '@/components/Charts/RadialBase'
import reportMultiple from '@/components/Multiple'

import tableBase from '@/components/Tables/TableBase'
import dataTable from '@/components/Tables/TableWithTotals'
import JsonCSV from 'vue-json-csv'

export default {
  name: `Dashboard Operational`,

  components: {
    'chart-line': chartLine,
    'radial-chart': RadialBase,
    'table-base': tableBase,
    'data-table': dataTable,
    'download-csv': JsonCSV,
    'report-multiple': reportMultiple
  },

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
    this.loadCober()
    this.loadProgress()
    this.processMuestra()
    this.getTelefonico()
    this.getSavedReports()
    this.getFilIncidencias()

  },

  data: function () {
    return {
      backConf: {
        path: '/charts/avancegeneral',
        pathMuestra: '/charts/muestra/',
        pathCober: '/charts/cobertura/',
        pathReports: '/formularios/reporte/',
        pathGetReports: '/formularios/savereporte/',
        pathPhone: '/callcenter/osdial-remarcaciones/',
        pathIncidencias: '/callcenter/camp-inc/',
        pathAgente: '/callcenter/agentes_inc/',
        pathIncEnc: '/charts/enc_inc/',
        pathHVEnc: '/charts/zona_mst/',
        page: 1
      },
      operativo: null,
      usuario: null,

      muestra_obj: null,
      municipios_obj: null,
      list_departamentos: [],
      list_municipios: [],
      list_mnz: [],
      select_dep: false,
      select_mun: false,
      select_mnz: false,

      progressSize: 70,
      progressWidth: 7,

      tabs: null,
      tabsKey: 0,

      chartSeriesCober: [0],
      chartOptionsCober: {
        chart: {
          toolbar: {
            show: true
          }
        },
        plotOptions: {
          radialBar: {
            startAngle: -120,
            endAngle: 120,
            hollow: {
              margin: 0,
              size: '70%',
              background: '#fff',
              image: undefined,
              imageOffsetX: 0,
              imageOffsetY: 0,
              position: 'front'
              // dropShadow: {
              //   enabled: true,
              //   top: 3,
              //   left: 0,
              //   blur: 4,
              //   opacity: 0.24
              // }
            },
            track: {
              background: '#fff',
              strokeWidth: '67%',
              margin: 0, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: -3,
                left: 0,
                blur: 4,
                opacity: 0.35
              }
            },

            dataLabels: {
              show: true,
              name: {
                offsetY: -10,
                show: true,
                color: '#888',
                fontSize: '17px'
              },
              value: {
                formatter: function (val) {
                  return parseFloat(val).toFixed(1) + ' %'
                },
                color: '#111',
                fontSize: '36px',
                show: true
              }
            }
          }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: ['#ABE5A1'],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100],
            colorStops: [
              {
                offset: 0,
                color: '#EB656F',
                opacity: 1
              },
              {
                offset: 100,
                color: '#95DA74',
                opacity: 1
              }
            ]
          }
        },
        stroke: {
          lineCap: 'round'
        },
        labels: ['Porcentaje']
      },
      chartCoberKey: 0,
      loadingCober: false,

      seriesAdv: null,
      advance: true,
      chartSeriesAdv: null,
      chartOptionsAdv: {
        chart: {
          zoom: {
            type: 'x',
            enabled: true
          }
        },
        colors: ['#008FFB', '#00E396', '#FF4560'],
        dataLabels: {
          enabled: true
        },
        legend: {
          show: true,
          position: 'bottom'
        },
        stroke: {
          curve: 'smooth'
        },

        responsive: [
          {
            breakpoint: 721,
            options: {
              legend: {
                position: 'bottom'
              }
            }
          }
        ],

        markers: {
          size: 5,

          hover: {
            sizeOffset: 6
          }
        },
        xaxis: {
          type: 'datetime',
          labels: {
            rotate: -15,
            rotateAlways: true
          },
          title: {
            text: 'Fecha'
          }
        },
        yaxis: [
          {
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: '#008FFB'
            },
            labels: {
              style: {
                color: '#008FFB'
              }
            },
            title: {
              text: 'Avance Diario',
              style: {
                color: '#008FFB'
              }
            },
            tooltip: {
              enabled: true
            }
          },
          {
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: '#00E396'
            },
            labels: {
              style: {
                color: '#00E396'
              }
            },
            opposite: true,
            title: {
              text: 'Avance Acumulado',
              style: {
                color: '#00E396'
              }
            },
            tooltip: {
              enabled: true
            }
          },
          {
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: '#FF4560'
            },
            labels: {
              style: {
                color: '#FF4560'
              }
            },
            opposite: true,
            title: {
              text: 'No Efectividad',
              style: {
                color: '#FF4560'
              }
            },
            tooltip: {
              enabled: true
            }
          }
        ]
        // tooltip: {
        //   fixed: {
        //     enabled: true,
        //     position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
        //     offsetY: 30,
        //     offsetX: 60
        //   }
        // }
      },
      chartAdvKey: 0,
      loadingAdv: false,

      //  Cobertura de Muestra
      // loadingSaved: false,
      loadingMuestra: false,
      selectedMuestra: null,
      savedMuestra: [],
      headersMuestra: [],
      dataValsMuestra: [],
      labelsMuestra: {},
      fieldsMuestra: [],
      tableMuestraKey: 0,
      loadMuestra: false,

      headersEncInc: [],
      dataValsEncInc: [],

      headersHogInc: [],
      dataValsHogInc: [],

      headersVivInc: [],
      dataValsVivInc: [],

      telefonico: null,
      dataValsMarc: [],
      headersMarc: [
        { text: 'Marcaciones', value: 'marcacion' },
        { text: 'Total', value: 'total' }
      ],
      labelsMarc: {
        marcacion: 'Marcaciones',
        total: 'Total'
      },

      fieldsMarc: [ 'marcacion', 'total' ],
      tableKeyMarc: 0,
      loadingMarc: 0,
      //incidencia
      dataValsInci: [],
      headersInci: [
        { text: 'Incidencias', value: 'incidencia' },
        { text: 'Total', value: 'total' }
      ],
      tableKeyInci: 0,
      loadingInci: 0,
      //agente
      savedAge: [],
      selectedAge: null,
      dataValsAge: [],
      headersAge: [
        { text: 'Incidencias', value: 'incidencia', str: 'Total' },
        { text: 'Total', value: 'total' }
      ],
      labelsAge: {
        inicidencia: 'Incidencias',
        total: 'Total'
      },
      fieldsAge: [ 'incidencia', 'total' ],
      tableKeyAge: 0,
      loadingAge: 0,

      chartSeriesGS: [
        {
          name: 'Femenino',
          data: [-0.8, -1.05, -1.06, -1.18, -1.4, -2.2, -2.85, -3.7, -3.96, -4.22, -4.3, -4.4,
            -4.1, -4, -4.1, -3.4, -3.1, -2.8
          ]
        },
        {
          name: 'Masculino',
          data: [0.4, 0.65, 0.76, 0.88, 1.5, 2.1, 2.9, 3.8, 3.9, 4.2, 4, 4.3, 4.1, 4.2, 4.5,
            3.9, 3.5, 3
          ]
        }
      ],
      chartOptionsGS: {
        chart: {
          type: 'bar',
          stacked: true
        },
        colors: ['#FF4560', '#008FFB'],
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '80%'
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },

        grid: {
          xaxis: {
            lines: {
              show: false
            }
          }
        },
        yaxis: {
          min: -5,
          max: 5,
          title: {
            // text: 'Age',
          }
        },
        tooltip: {
          shared: false,
          x: {
            formatter: function (val) {
              return val
            }
          },
          y: {
            formatter: function (val) {
              return Math.abs(val) + '%'
            }
          }
        },
        // title: {
        //   text: 'Mauritius population pyramid 2011'
        // },
        xaxis: {
          categories: ['85+', '80-84', '75-79', '70-74', '65-69', '60-64', '55-59', '50-54',
            '45-49', '40-44', '35-39', '30-34', '25-29', '20-24', '15-19', '10-14', '5-9',
            '0-4'
          ],
          title: {
            text: 'Percent'
          },
          labels: {
            formatter: function (val) {
              return Math.abs(Math.round(val))
            }
          }
        }
      },
      chartGSKey: 0,

      // seriesBrush: chartSeriesAdv,
      chartOptionsBrush: {
        chart: {
          id: 'chart2',
          type: 'line',
          height: 230,
          toolbar: {
            autoSelected: 'pan',
            show: false
          }
        },
        colors: ['#546E7A'],
        stroke: {
          width: 3
        },
        dataLabels: {
          enabled: false
        },
        fill: {
          opacity: 1
        },
        markers: {
          size: 0
        },
        xaxis: {
          type: 'datetime'
        }
      },
      // seriesLineBrush: chartSeriesAdv,
      chartOptionsLineBrush: {
        chart: {
          id: 'chart1',
          height: 130,
          type: 'area',
          brush: {
            target: 'chart2',
            enabled: true
          },
          selection: {
            enabled: true,
            xaxis: {
              min: new Date('19 Jun 2017').getTime(),
              max: new Date('14 Aug 2017').getTime()
            }
          }
        },
        colors: ['#008FFB'],
        fill: {
          type: 'gradient',
          gradient: {
            opacityFrom: 0.91,
            opacityTo: 0.1
          }
        },
        xaxis: {
          type: 'datetime',
          tooltip: {
            enabled: false
          }
        },
        yaxis: {
          tickAmount: 2
        }
      },
      brushKey: 0,

      // Reporte Multiple
      loadingSaved: false,
      loadingReports: false,
      selectedReport: null,
      savedReports: [],

      dateIniReports: null,
      dateEndReports: null,

      dataReports: [],
      csvnameReports: ' '
    }
  },

  watch: {
    '$store.state.actualOperation': function () {
      this.operativo = this.$store.state.actualOperation.id
    },

    selectedReport: function () {
      this.reply()
    },

    selectedAge: function () {
      this.dataValsAge = this.selectedAge.usuario[this.selectedAge]
      this.loadDataAgeResp()
      this.tableKeyAge += 1
    },

    select_dep: function () {
      this.list_municipios = []
      this.list_mnz = []
      this.select_mnz = false
      this.select_mun = false
      let munToReturn = []
      let munToSearch = Object.keys(this.muestra_obj[this.select_dep])
      let t = this
      munToSearch.forEach(function (mun) {
        munToReturn.push(t.municipios_obj[mun])
      })
      this.list_municipios = munToReturn
    },

    select_mun: function () {
      this.list_mnz = []
      this.select_mnz = false
      this.list_mnz = this.muestra_obj[this.select_dep][this.select_mun]
    },

    operativo: function () {
      this.loadDataInci()
      this.loadDataAge()
      this.loadDataAgeResp()


    },
  },

  computed: {


  },

  methods: {
    /**
     * Carga los datos de avance general y acumulado
     */
    loadProgress () {
      this.loadingAdv = true
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          operativo: this.operativo
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.seriesAdv = resp.data
          t.ChangeAdvance()
          t.loadingAdv = false
          t.chartAdvKey += 1
        })
        .catch(function (err) {
          t.seriesAdv = null
          t.ChangeAdvance()
          t.loadingAdv = false
          console.error(err)
        })
    },

    /**
     * Cambia entre las opciones Acumulado y Diario
     */
    ChangeAdvance () {
      if (this.advance) { // Acumulado
        this.chartSeriesAdv = this.seriesAdv.slice(1, 2)
        this.chartOptionsAdv.colors = ['#00E396']
        this.chartOptionsAdv.yaxis = [
          {
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: '#00E396'
            },
            labels: {
              style: {
                color: '#00E396'
              }
            },
            title: {
              text: 'Avance Acumulado',
              style: {
                color: '#00E396'
              }
            },
            tooltip: {
              enabled: true
            }
          }
        ]
      } else { // Diario
        this.chartSeriesAdv = this.seriesAdv.slice(0, 1).concat(this.seriesAdv.slice(2))
        this.chartOptionsAdv.colors = ['#008FFB', '#FF4560']
        this.chartOptionsAdv.yaxis = [
          {
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: '#008FFB'
            },
            labels: {
              style: {
                color: '#008FFB'
              }
            },
            title: {
              text: 'Avance Diario',
              style: {
                color: '#008FFB'
              }
            },
            tooltip: {
              enabled: true
            }
          },
          {
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: '#FF4560'
            },
            labels: {
              style: {
                color: '#FF4560'
              }
            },
            opposite: true,
            title: {
              text: 'No Efectividad',
              style: {
                color: '#FF4560'
              }
            },
            tooltip: {
              enabled: true
            }
          }
        ]
      }
      this.advance = !this.advance
      this.chartAdvKey += 1
    },

    /**
     * Carga el avance de la cobertura
     */
    loadCober () {
      this.loadingCober = true
      let request = {
        method: 'get',
        url: this.backConf.pathCober,
        params: {
          operativo: this.operativo
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.chartSeriesCober = resp.data
          t.loadingCober = false
          t.chartAdvKey += 1
        })
        .catch(function (err) {
          t.chartSeriesCober = [0]
          t.loadingCober = false
          console.error(err)
        })
    },

    /**
     * Procesa los datos para la tabla cobertura agregando los datos faltantes de la tabla
     */
    processMuestra () {
      this.loadMuestra = true
      let request = {
        method: 'get',
        params: {
          operativo: this.operativo
        },
        url: this.backConf.pathMuestra
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          // obtiene las keys para values, retirando los de meta y conteo
          let vals = Object.keys(resp.data[0])
          vals.splice(vals.length - 2)
          let totMeta = 0
          let totCont = 0

          // calcualr el porcentaje y formatea los datos
          resp.data.forEach(function (element) {
            totMeta += element.meta
            totCont += element.conteo

            let perc = element.conteo / element.meta * 100
            perc = Number.parseFloat(perc).toFixed(1)

            let obj = {
              meta: element.meta,
              conteo: element.conteo,
              porcentaje: perc === 'NaN' ? Number.parseFloat(0).toFixed(1) : perc
            }
            // agrega las keys y los valores de los values, para mostrar
            vals.forEach(function (key) {
              obj[key] = element[key]
            })

            t.dataValsMuestra.push(obj)
          })

          let ponder = totCont / totMeta * 100
          t.tableConfig(vals, Number.parseFloat(ponder).toFixed(1))

          t.tableMuestraKey += 1
          t.loadMuestra = false
        })
        .catch(function (err) {
          t.dataValsMuestra = []
          t.loadMuestra = false
          console.error(err)
        })
    },

    /**
     * Consulta los datos para los filtros de Incidencias
     */
    getFilIncidencias () {
      let request = {
        method: 'get',
        params: {
          operativo: this.operativo
        },
        url: this.backConf.pathHVEnc
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.muestra_obj = resp.data.rel
          t.list_departamentos = resp.data.dep
          t.municipios_obj = resp.data.mun
        })
        .catch(function (err) {
          console.error(err)
        })
    },

    /**
     * Procesa los datos para la tabla de Incidencias por encuestador
     */
    getEncIncidencias () {
      let request = {
        method: 'post',
        data: {
          operativo: this.operativo
        },
        url: this.backConf.pathIncEnc
      }
      if (this.select_dep !== false) {
        request.data.depto = this.select_dep
      }
      if (this.select_mun !== false) {
        request.data.municipio = this.select_mun
      }
      if (this.select_mnz !== false) {
        request.data.mnz = this.select_mnz
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataValsEncInc = []
          t.headersEncInc = []
          // obtiene las keys para values, retirando los de meta y conteo
          let vals = Object.keys(resp.data[0])

          vals.forEach(function (element) {
            let header = {
              text: element,
              value: element
            }
            t.headersEncInc.push(header)
          })

          t.dataValsEncInc = resp.data
        })
        .catch(function (err) {
          t.dataValsEncInc = []
          console.error(err)
        })
    },

    /**
     * Procesa los datos para la tabla de Incidencias por Hogar
     */
    getHogIncidencias () {
      let request = {
        method: 'post',
        data: {
          operativo: this.operativo,
          tipo: 'hogar'
        },
        url: this.backConf.pathHVEnc
      }
      if (this.select_dep !== false) {
        request.data.depto = this.select_dep
      }
      if (this.select_mun !== false) {
        request.data.municipio = this.select_mun
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataValsHogInc = []
          t.headersHogInc = []
          let vals = Object.keys(resp.data[0])

          vals.forEach(function (element) {
            let header = {
              text: element,
              value: element
            }
            t.headersHogInc.push(header)
          })

          t.dataValsHogInc = resp.data
        })
        .catch(function (err) {
          t.dataValsHogInc = []
          console.error(err)
        })
    },

    /**
     * Procesa los datos para la tabla de Incidencias por Vivienda
     */
    getVivIncidencias () {
      let request = {
        method: 'post',
        data: {
          operativo: this.operativo,
          tipo: 'manzana'
        },
        url: this.backConf.pathHVEnc
      }

      if (this.select_dep !== false) {
        request.data.depto = this.select_dep
      }
      if (this.select_mun !== false) {
        request.data.municipio = this.select_mun
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataValsVivInc = []
          t.headersVivInc = []
          // obtiene las keys para values, retirando los de meta y conteo
          let vals = Object.keys(resp.data[0])

          vals.forEach(function (element) {
            let header = {
              text: element,
              value: element
            }
            t.headersVivInc.push(header)
          })

          t.dataValsVivInc = resp.data
        })
        .catch(function (err) {
          t.dataValsVivInc = []
          console.error(err)
        })
    },

    /**
     * Procesa los datos para la tabla de Incidencias por Vivienda
     */
    getIncidencias () {
      this.getEncIncidencias()
      this.getHogIncidencias()
      this.getVivIncidencias()
    },

    /**
     * Confogura valores necesarios para el funcioanimiento de la tabla,
     * headers, labels y fields
     * @param  {array}   values Lista de valores a agregar
     * @param  {integer} ponder Valor ponderado, para adjuntar a la tabla
     */
    tableConfig (values, ponder) {
      let head = []

      values.forEach(function (key) {
        let obj = {
          text: key,
          align: 'left',
          value: key,
          str: ' '
        }
        head.push(obj)
      })

      head[head.length - 1].str = 'Totales'

      this.headersMuestra = head.concat([
        { text: 'Muestra', value: 'meta', align: 'right' },
        { text: 'Conteo', value: 'conteo', align: 'right' },
        { text: 'Avance %', value: 'porcentaje', align: 'right', str: ponder }
      ])

      // Agrega los Labels para el CSV
      let obj = {}

      values.forEach(function (key) {
        obj[key] = key
      })

      this.labelsMuestra = Object.assign(obj, {
        meta: 'Muestra',
        conteo: 'Conteo',
        porcentaje: 'Avance'
      })

      // Agrega los Fields para el CSV
      this.fieldsMuestra = values.concat(['meta', 'conteo', 'porcentaje'])
    },

    // para reporte telefónico
    /**
     * Obtiene los valores de lso reportes telefonicos
     */
    getTelefonico () {
      this.loadingMarc = true

      let request = {
        method: 'get',
        params: {
          operativo: this.operativo
        },
        url: this.backConf.pathPhone
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataValsMarc = resp.data
          t.tableKeyMarc += 1
          t.loadingMarc = false
        })
        .catch(function (err) {
          t.dataValsMarc = null
          t.loadingMarc = false
          console.error(err)
        })
    },

    getInc () {
      this.loadingInci = true

      let request = {
        method: 'get',
        params: {
          operativo: this.operativo
        },
        url: this.backConf.pathIncidencias
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataValsInci = resp.data
          t.tableKeyInci += 1
          t.loadingInci = false
        })
        .catch(function (err) {
          t.dataValsInci = []
          t.loadingInci = false
          console.error(err)
        })
    },
    getAge () {
      this.loadingAge = true

      let request = {
        method: 'get',
        params: {
          operativo: this.operativo
        },
        url: this.backConf.pathAgente
      }


      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.savedAge = resp.data
          t.tableKeyAge += 1
          t.loadingAge = false
        })
        .catch(function (err) {
          t.savedAge = []
          t.loadingAge = false
          console.error(err)
        })
    },

    getAgeResp () {
      this.loadingAge = true

      let request = {
        method: 'post',
        data: {
          operativo: this.operativo,
          usuario: this.selectedAge.usuario
        },
        url: this.backConf.pathAgente
      }

      //console.log(JSON.stringify(request))
      let t = this
      this.$store.dispatch('request_back', request)
      .then(function (resp) {
        t.dataValsAge = resp.data
        t.tableKeyAge += 1
        t.loadingAge = false
      })
      .catch(function (err) {
        t.dataValsAge = []
        t.loadingAge = false
        console.error(err)
      })
    },

      // para reporte multiple
    /**
     * Obtiene la lista de reportes guardados
     */
    getSavedReports () {
      this.loadingSaved = true

      let request = {
        method: 'get',
        params: {
          operativo: this.operativo
        },
        url: this.backConf.pathGetReports
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.savedReports = resp.data
          t.loadingSaved = false
        })
        .catch(function (err) {
          t.savedReports = null
          t.loadingSaved = false
          console.error(err)
        })
    },

    /**
     * Obtiene las respuestas de la pregunta solicitada
     */
    reply () {
      this.loadingReports = true

      let request = {
        method: 'post',
        data: {
          operativo: this.operativo,
          data: this.selectedReport.data.query,
          fecha_i: this.dateIniReports,
          fecha_f: this.dateEndReports
        },
        url: this.backConf.pathReports
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataReports = resp.data
          t.csvnameReports = t.selectedReport.nombre
          t.loadingReports = false
        })
        .catch(function (err) {
          t.dataReports = []
          t.loadingReports = false
          console.error(err)
        })
    },
    loadDataInci () {
      this.getInc()
    },
    loadDataAge () {
      this.getAge()
    },

    loadDataAgeResp () {
      this.getAgeResp()
    },


  }
}
</script>
